import { TableRow as MuiTableRow, TableRowProps } from '@mui/material';

const TableRow = (props: TableRowProps) => {
  return <MuiTableRow {...props} />;
};

export default TableRow;
